export default __webpack_public_path__ + "static/media/testResult.a3e89d19.svg";